import {
  GlobalEvents,
  SectionElement,
  defineElement
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-RGTSXKO2.js";

// src/sections/common-cart/common-cart.ts
var CommonCart = class extends SectionElement {
  connectedCallback() {
    GlobalEvents.emit("cart:open");
  }
};
CommonCart = __decorateClass([
  defineElement("common-cart")
], CommonCart);
export {
  CommonCart
};
